export enum RedirectType {
  success = 'success',
  error = 'error',
  failure = 'failure',
}
